import { cn } from "@workspace/ui/lib/utils";

import { AllCurrenciesContent } from "./all-currencies-content";

export function AllCurrencies({
	value = 0,
	className,
	currency,
}: {
	value?: number | null | undefined;
	className?: string;
	currency?: string;
}) {
	return (
		<span
			className={cn(
				"text-sm text-muted-foreground flex flex-col gap-1",
				className,
			)}
		>
			<AllCurrenciesContent value={value} currency={currency} />
		</span>
	);
}
